const routes = [
  {
    path: 'aggridfilter',
    name: 'aggridfilter',
    component: () => import(/* webpackChunkName: "aggridfilter" */ '@/modules/aggridfilter/index.vue')
  },
];

export default routes;